module.exports = __webpack_public_path__ + "img/banner1.bak.e73f2cfc.png";